import {useHasWalletFeature} from '~/api/deimos/wallet'

import {useOpenBankingTransactionLimit} from './use-open-banking-transaction-limit'

export const useIsOpenBankingEnabled = () => {
    const {hasWalletFeature: hasOpenBankingPermission} = useHasWalletFeature('OPEN_BANKING')
    const openBankingAmountLimit = useOpenBankingTransactionLimit()

    return hasOpenBankingPermission && typeof openBankingAmountLimit !== 'undefined'
}
